import { toDepartmentFilterOptions, IDepartmentOptionSource } from '@vacationtracker/shared/functions/department-options'
import { ILocationFilterSource, locationOptionsByCountry } from '@vacationtracker/shared/functions/location-country-groups'
import type { FilterOption } from '../../../../design-system/FilterTrigger'

/** What a department or location picker offers, built the way the filter bar builds its own. */
export interface IMoveTargetOptions {
  options: FilterOption[]
  keepOrder: boolean
}

export interface IMoveTargets {
  teams: IMoveTargetOptions
  locations: IMoveTargetOptions
}

export function departmentMoveTargets(teams: IDepartmentOptionSource[]): IMoveTargetOptions {
  return { options: toDepartmentFilterOptions(teams), keepOrder: false }
}

export function locationMoveTargets(locations: ILocationFilterSource[], noCountryLabel: string): IMoveTargetOptions {
  const byCountry = locationOptionsByCountry(locations, noCountryLabel)
  return { options: byCountry ?? locations.map((location) => ({ value: location.id, label: location.name })), keepOrder: Boolean(byCountry) }
}
